import React from 'react';
export function PrivacyPolicy() {
  return <div className="prose prose-sm max-w-none text-[#3D3028]/80" data-id="element-233">
      <h3 className="text-lg font-semibold text-[#3D3028] mb-4" data-id="element-234">
        Política de Privacidad
      </h3>

      <p className="mb-4" data-id="element-235">Última actualización: Diciembre 2024</p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-236">
        1. Información que Recopilamos
      </h4>
      <p className="mb-4" data-id="element-237">
        Recopilamos información personal que nos proporcionas voluntariamente al
        registrarte en nuestro curso, incluyendo nombre, correo electrónico y
        datos de pago necesarios para procesar tu compra.
      </p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-238">
        2. Uso de la Información
      </h4>
      <p className="mb-4" data-id="element-239">Utilizamos tu información para:</p>
      <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-240">
        <li data-id="element-241">Procesar tu inscripción y pagos</li>
        <li data-id="element-242">Proporcionar acceso al contenido del curso</li>
        <li data-id="element-243">Enviarte actualizaciones y material educativo</li>
        <li data-id="element-244">Mejorar nuestros servicios</li>
      </ul>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-245">
        3. Protección de Datos
      </h4>
      <p className="mb-4" data-id="element-246">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado, pérdida o
        alteración.
      </p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-247">
        4. Compartir Información
      </h4>
      <p className="mb-4" data-id="element-248">
        No vendemos ni compartimos tu información personal con terceros, excepto
        cuando sea necesario para procesar pagos o cumplir con requisitos
        legales.
      </p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-249">
        5. Cookies
      </h4>
      <p className="mb-4" data-id="element-250">
        Utilizamos cookies para mejorar tu experiencia de navegación y analizar
        el uso de nuestro sitio web.
      </p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-251">
        6. Tus Derechos
      </h4>
      <p className="mb-4" data-id="element-252">
        Tienes derecho a acceder, corregir o eliminar tu información personal en
        cualquier momento.
      </p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-253">
        7. Cambios a esta Política
      </h4>
      <p className="mb-4" data-id="element-254">
        Nos reservamos el derecho de actualizar esta política de privacidad. Te
        notificaremos sobre cambios significativos mediante correo electrónico.
      </p>
    </div>;
}